export const buildingDetail = {
  title: "Building Details",
  description: "View and manage building information",
  basicInfo: "Basic Information",
  additionalDetails: "Additional Details",
  brief: {
    title: "Project Brief",
    description: "Project overview and requirements",
    basics: "Basics",
    technical: "Technical",
    systems: "Systems",
    requirements: "Requirements",
    export: "Export Brief",
    exportSuccessTitle: "Brief Exported",
    exportSuccessDesc: "Project brief has been exported successfully",
    exportErrorDesc: "Failed to export project brief",
    updateSuccessTitle: "Brief Updated",
    updateSuccessDesc: "Project brief has been updated successfully",
    updateErrorDesc: "Failed to update project brief",
    loadError: "Failed to load project brief",
  },
  insights: {
    title: "Building Insights",
    description: "AI-generated insights and recommendations",
    analyze: "Analyse Building",
    showActive: "Show Active",
    showResolved: "Show Resolved",
    noInsights: "No Insights",
    noActiveInsights: "No active insights. Click 'Analyse Building' to scan for potential issues.",
    noResolvedInsights: "No resolved insights.",
    failedToLoad: "Failed to load insights. Please try again.",
    loadError: "Error",
    recommendations: "Recommendations:",
    resolve: "Resolve",
    resolvedOn: "Resolved on:",
    energyPerformance: {
      title: "Energy Performance Analysis",
      description: "Assessment of building energy efficiency based on available data",
      highConsumption: "High energy consumption detected",
      lowEfficiency: "Low energy efficiency rating",
      goodPerformance: "Good energy performance",
      noData: "Insufficient energy data available",
      ratings: {
        description:
          "The building has an energy efficiency rating of {rating}, indicating {performance} energy performance.",
        a: "excellent",
        b: "very good",
        c: "good",
        d: "moderate",
        e: "below average",
        f: "poor",
        g: "very poor",
      },
      recommendations: {
        audit: "Conduct a comprehensive energy audit",
        upgrade: "Upgrade to energy-efficient systems and appliances",
        renewable: "Consider implementing renewable energy sources",
        monitoring: "Install energy consumption monitoring systems",
        insulation: "Improve building insulation to reduce heat loss",
        windows: "Upgrade windows to energy-efficient models",
        envelope: "Consider a building envelope retrofit",
        smartSystem: "Implement a smart building management system",
        heatPump: "Consider switching to a heat pump system",
        biomass: "Evaluate renewable heating options like biomass or solar thermal",
        solarThermal: "Install solar thermal collectors for water heating",
        hybridSystem: "Implement a hybrid heating system to reduce fossil fuel consumption",
        energyAssessment: "Conduct an energy performance assessment",
        retrofitStrategy: "Develop a comprehensive energy retrofit strategy",
        deepRetrofit: "Consider deep energy retrofit for maximum savings",
        subsidies: "Apply for green building renovation incentives or subsidies",
        maintenanceCheck: "Schedule maintenance check for all HVAC systems",
        replaceOldSystems: "Consider replacing systems that are over 15 years old",
        highEfficiencyEquipment: "Upgrade to high-efficiency HVAC equipment",
        smartControls: "Implement smart controls for optimal system operation",
      },
    },
    fireSafety: {
      title: "Fire Safety Analysis",
      description: "Assessment of building fire safety systems and components",
      improvementsNeeded: "Fire Safety Improvements Needed",
      enhancementsRecommended: "Fire Safety Enhancements Recommended",
      missingComponents: "Building is missing essential fire safety components: {components}",
      additionalMeasures: "Additional fire safety measures recommended to improve building safety",
      recommendations: {
        fireAlarm: "Install an approved fire alarm system",
        emergencyLighting: "Ensure proper emergency lighting is in place",
        evacuationRoutes: "Mark evacuation routes clearly",
        smokeDetectors: "Install smoke detectors in critical areas",
        sprinklerSystem: "Consider implementing a sprinkler system",
        fireExtinguishers: "Place fire extinguishers at accessible locations on each floor",
        emergencyExits: "Ensure emergency exits are clearly marked",
        fireDrills: "Conduct regular fire safety drills",
        safetyPlan: "Create a building fire safety plan",
      },
    },
    priority: {
      low: "Low",
      medium: "Medium",
      high: "High",
      critical: "Critical",
    },
  },
  actions: {
    title: "Building Actions",
    viewESG: "ESG Report",
    viewBrief: "Project Brief",
    viewLCA: "Life Cycle Assessment",
    viewBudget: "Budget",
    viewPermits: "Permits",
    viewPayments: "Payments",
    viewBudgetProjections: "Budget Projections",
  },
  overview: {
    dataQuality: "Data Quality",
    dataCompletenessDesc: "Building data completeness",
    documents: "Documents",
    documentsDesc: "Total documents uploaded",
    lastUpdated: "Last Updated",
    lastUpdatedDesc: "Most recent data update",
    title: "Building Overview",
  },
  dashboard: {
    registryCode: "Registry Code",
    netArea: "Net Area",
    floors: "Floors",
    floorsUnderground: "underground",
    heatingSource: "Heating Source",
    editBuilding: "Edit",
    fieldsSaved: "Building details updated",
    fieldsSaveError: "Failed to update building details",
    uploadDocuments: "Upload documents",
    projects: "Projects",
    documents: "Document analytics",
    analyticsPartialAccess:
      "Analytics aren't shown because you don't have access to all of this project's documents.",
    total: "Total files",
    processed: "Processed",
    filesAllProcessed: "{count} files · all processed",
    fileAllProcessedOne: "1 file · processed",
    unsupportedTypesTooltip:
      "Some uploaded file types are not yet supported by Franklin smart processing, so they're excluded from these counts.",
    documentsByGroup: "Documents by",
    expandChart: "Expand chart",
    legendShowMore: "+{count} more",
    groupCategory: "Category",
    groupDiscipline: "Discipline",
    groupStage: "Stage",
    uploadActivity: "Upload Activity",
    documentsPerProject: "Documents per Project",
    range30d: "30d",
    range90d: "90d",
    range1y: "1y",
    tooltipTotal: "Total",
    noDocuments: "No documents",
    noData: "No data",
    noUploads30d: "No uploads in the last 30 days",
    noUploads90d: "No uploads in the last 90 days",
    noUploads1y: "No uploads in the last year",
    noUploadsHint: "Try a longer time range",
    other: "Other",
  },
};
